import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./TourList.css";

function TourList() {
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);

 useEffect(() => {
  fetch("https://mdt.24x7it.in/api/tour-list?tour_type=bayahibe")
    .then(res => res.json())
    .then(data => {
      setTours(data.tours || []);
      setLoading(false);
    })
    .catch(err => {
      console.error(err);
      setLoading(false);
    });
}, []);

useEffect(() => {
  window.snapSaveState = () => !loading;
}, [loading]);

  return (
    <>
      <Helmet>
        <title>Bayahibe Tours</title>
        <meta
          name="description"
          content="Explore Bayahibe tours and adventures."
        />
      </Helmet>

      <div className="container">
        <h1 className="page-title">Bayahibe Tours</h1>

        {loading ? (
          <p className="loading">Loading tours...</p>
        ) : (
          <div className="tour-grid">
            {tours.map((tour) => (
              <div key={tour.id} className="tour-card">
                
                <img
                  src={tour.image || "https://via.placeholder.com/400x250"}
                  alt={tour.title}
                  className="tour-image"
                />

                <div className="tour-content">
                  <h3>{tour.title}</h3>

                  <p>
                    {tour.short_description
                      ? tour.short_description.substring(0, 100) + "..."
                      : "Explore this amazing tour experience."}
                  </p>

                  <Link to={`/tour/${tour.id}`} className="btn">
                    View Details
                  </Link>
                </div>

              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}

export default TourList;